const HorizontalRule = (props) => (
  <svg width='24' height='24' viewBox='0 0 24 24' {...props}>
    <path fillRule='evenodd' d='M4 11h16v2H4z' />
  </svg>
)

export default HorizontalRule
